import {
    putInvoiceProviderReset,
    putInvoiceProviderLoading,
    putInvoiceProviderSuccess,
    putInvoiceProviderReject,
    putInvoiceProviderRequest
} from "../../actions/invoiceProvider/put";

export const putInvoiceProvider = (formData) => async (dispatch, getState) => {
    dispatch(putInvoiceProviderLoading());
    try {
        const { data } = await putInvoiceProviderRequest(formData, getState);
        dispatch(putInvoiceProviderSuccess(data))
    } catch (error) {
        dispatch(putInvoiceProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(putInvoiceProviderReset()) }, 3000);
    }
    return Promise.resolve();
};